var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterDisable(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12.5,
    viewBox: "0 0 18 12.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11971",
    "data-name": "Group 11971",
    transform: "translate(-942 -126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-filter",
    "data-name": "Icon awesome-filter",
    d: "M11.913,0H.587A.586.586,0,0,0,.172,1L4.688,5.516v5.031a.586.586,0,0,0,.25.48l1.953,1.367a.586.586,0,0,0,.922-.48v-6.4L12.328,1A.586.586,0,0,0,11.913,0Z",
    transform: "translate(942 126)",
    fill: "#6676AA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2870",
    "data-name": "Ellipse 2870",
    transform: "translate(952 126)",
    fill: "#fff",
    stroke: "red",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_397",
    "data-name": "Line 397",
    x2: 4,
    transform: "translate(954 130)",
    fill: "none",
    stroke: "#ff3a3a",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterDisable);
export default __webpack_public_path__ + "static/media/filter-disable.e50f44e65ffc5036bb17dc4764bafacc.svg";
export { ForwardRef as ReactComponent };